import React from 'react';
import { spaces } from '../../lib/styles';

interface Props {
    attribution: React.ReactNode;
    avatar: React.ReactNode;
}

export default function AvatarWithAttribution({ attribution, avatar }: Props) {
    return (
        <>
            <span style={{ marginRight: spaces.space5 }}>{avatar}</span>
            <span>{attribution}</span>
        </>
    );
}
